import { useQuery } from '@tanstack/react-query-v4'
import { useApi } from '@api/useApi.hook'
import { QueryKey } from '@api'
import { appConfig } from '@config'
import { useIsAuthenticated } from '@domain/auth/Auth.context'
import { useWeb3Ready } from '@domain/auth/context/Web3ReadyContext'
import type { FavoritesResponseDto } from './favorites.types'

const EMPTY_RESULT: FavoritesResponseDto = { items: [] }

export const useFavorites = () => {
  const { get } = useApi()
  const isAuthenticated = useIsAuthenticated()
  const web3Ready = useWeb3Ready()
  const isReady = isAuthenticated && (web3Ready?.ready ?? false)

  return useQuery({
    queryKey: [QueryKey.Favorites, isAuthenticated, isReady],
    enabled: isReady,
    queryFn: async (): Promise<FavoritesResponseDto> => {
      const response = await get<FavoritesResponseDto>(
        appConfig.endpoints.v1.favorites.main,
        {
          disableAutoSnakeCase: true,
        },
      )()

      return response || EMPTY_RESULT
    },
  })
}
